import { render, staticRenderFns } from "./bordereau.vue?vue&type=template&id=d06f5cea&"
import script from "./bordereau.vue?vue&type=script&lang=js&"
export * from "./bordereau.vue?vue&type=script&lang=js&"
import style0 from "./bordereau.vue?vue&type=style&index=0&id=d06f5cea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports